import React from 'react'
import StatusBadge from "../../components/StatusBadge/StatusBadge"

const HistoryTypeCell = ({ type }) => {
  return (
    <StatusBadge
      label={type?.label}
      bgColor={type?.bgColor || 'var(--color-error-500)'}
      textColor={type?.textColor || '#fff'}
    />
  )
}

export default HistoryTypeCell
